import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Printer } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DocumentSheet } from '@/components/documents/DocumentSheet';
import { documentPageStyle } from '@/components/documents/print';
import type { DocumentModel } from '@/components/documents/types';

/**
 * The same A4 sheet the office prints, flowed to the screen, plus a hidden
 * print copy driven by react-to-print (same wiring as EstimateQuickViewSheet).
 */
export function PortalDocumentView({ doc }: { doc: DocumentModel }) {
  const printRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: doc.number,
    pageStyle: documentPageStyle(doc.paper),
  });

  return (
    <div className="space-y-2">
      <div className="flex justify-end">
        <Button variant="outline" size="sm" className="gap-1.5" onClick={() => handlePrint()}>
          <Printer className="h-4 w-4" /> Print / Save PDF
        </Button>
      </div>
      <DocumentSheet doc={doc} variant="screen" />
      <div className="hidden print:block">
        <DocumentSheet ref={printRef} doc={doc} variant="print" />
      </div>
    </div>
  );
}
